// src/hooks/useWidgetDispatcher.js
import { useCallback } from 'react';

export const useWidgetDispatcher = (dependencies) => {
    const { setMessages, addProject, setActiveProject, showToast, sendQueryToApi, setIsLoading } = dependencies;

    // Mutación Determinista O(1): Usamos el ID exacto del mensaje para marcarlo completado
    const markWidgetCompleted = useCallback((messageId) => {
        setMessages(prev => prev.map(msg => 
            msg.id === messageId 
                ? { ...msg, widget: { ...msg.widget, completed: true } } 
                : msg
        ));
    }, [setMessages]);

    const dispatchWidgetAction = useCallback(async (actionType, payload, messageId) => {
        // 1. Inmediatamente mutamos la UI para dar feedback al usuario
        markWidgetCompleted(messageId);

        // 2. Enrutador de Casos de Uso (Command Pattern)
        switch (actionType) {
            case 'local_create_project':
                setMessages(prev => [...prev, { id: crypto.randomUUID(), sender: 'user', content: `Crear proyecto: ${payload.name}` }]);
                setIsLoading(true);
                try {
                    const projectPayload = { ...payload, size: payload.gross_area };
                    const newProject = await addProject(projectPayload);
                    
                    if (newProject) {
                        setActiveProject(newProject);
                        setMessages(prev => [...prev, { id: crypto.randomUUID(), sender: 'bot', content: `¡Proyecto "${newProject.name}" creado y seleccionado exitosamente!` }]);
                        showToast('Proyecto creado', 'success');
                    } else {
                        throw new Error('Error al generar proyecto');
                    }
                } catch (error) {
                    showToast('Error al guardar el proyecto', 'error');
                    setMessages(prev => [...prev, { id: crypto.randomUUID(), sender: 'bot', content: 'Hubo un error al crear tu proyecto.', isError: true }]);
                } finally {
                    setIsLoading(false);
                }
                break;

            case 'info-cbrainai':
                // Aquí podrías manejar la lógica del botón "Qué es CBrainAI" si lo integras como acción
                break;

            default:
                // Fallback dinámico para AWS Bedrock (Maneja cualquier otro widget generado por la IA)
                setMessages(prev => [...prev, { id: crypto.randomUUID(), sender: 'user', content: 'He completado el formulario con mis datos.' }]);
                const promptForBedrock = `Aquí están los datos solicitados del formulario (${actionType}): ${JSON.stringify(payload)}. Por favor procede a ejecutar la acción.`;
                await sendQueryToApi(promptForBedrock);
                break;
        }
    }, [markWidgetCompleted, addProject, setActiveProject, showToast, sendQueryToApi, setIsLoading, setMessages]);

    return { dispatchWidgetAction };
};